import { useQuery } from "@tanstack/react-query";
import { getAuthenticatedRequest } from "../utils/API/api.ts";

export const useGetUserEvent = ({ tab, page }) => {
  return useQuery({
    queryKey: ["userEvent", tab, page],
    queryFn: async () => {
      let url = `/user/events?page=${page}`;
      if (tab) {
        url = `/user/events?filter=${tab?.toLowerCase()}&page=${page}`;
      }
      const response = await getAuthenticatedRequest(url);
      return response?.data;
    },
    staleTime: 5 * 60 * 1000,
  });
};
